import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";
import { isDemoMode, isBrowserSessionDemo } from "../utils/demoConfig";
import { getMockResponse } from "../utils/mockApi";

const API_URL = process.env.REACT_APP_API_URL_BASE;

export function resolveDropdownLabel(item, labelField, valueField = "id") {
  const primary = item?.[labelField];
  if (primary != null && String(primary).trim() !== "") {
    return String(primary);
  }
  if (item?.friendly_name) {
    return String(item.friendly_name);
  }
  if (item?.username) {
    return String(item.username);
  }
  const fullName = [item?.first_name, item?.last_name].filter(Boolean).join(" ").trim();
  if (fullName) {
    return fullName;
  }
  if (item?.email) {
    return String(item.email);
  }
  return String(item?.[valueField] ?? "");
}

const AsyncDropdownNormal = ({
  value,
  onChange,
  placeholder = "Search...",
  endpoint,
  subUserEndpoint,
  parentUserOnly = "",
  queryParams = "",
  fetchOptions = {},
  labelField,
  valueField = "id",
  fieldName,
  extraFields = [],
  ...props
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchOptionsData = async (query = "") => {
    try {
      setLoading(true);
      const sub = subUserEndpoint == null ? "" : String(subUserEndpoint);
      const relPath = `${endpoint}/${sub}?search=${encodeURIComponent(query)}${parentUserOnly}${queryParams}`;

      if (isDemoMode() || isBrowserSessionDemo()) {
        const data = getMockResponse(relPath);
        const rows = data && Array.isArray(data.results) ? data.results : [];
        const formattedData = rows.map((item) => {
          const formattedItem = {
            value: item[valueField],
            label: resolveDropdownLabel(item, labelField, valueField),
          };
          extraFields.forEach((field) => {
            if (item[field] !== undefined) {
              formattedItem[field] = item[field];
            }
          });
          return formattedItem;
        });
        setOptions(formattedData);
        return formattedData;
      }

      const response = await fetch(
        `${API_URL}${relPath}`,
        fetchOptions
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      const formattedData = data.results.map((item) => {
        const formattedItem = {
          value: item[valueField],
          label: resolveDropdownLabel(item, labelField, valueField),
        };

        extraFields.forEach((field) => {
          if (item[field] !== undefined) {
            formattedItem[field] = item[field];
          }
        });

        return formattedItem;
      });

      setOptions(formattedData);
      return formattedData;
    } catch (error) {
      console.error(error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const loadOptions = (inputValue, callback) => {
    fetchOptionsData(inputValue).then((options) => callback(options));
  };

  useEffect(() => {
    fetchOptionsData();
  }, [subUserEndpoint]);

  return (
    <AsyncSelect
      key={subUserEndpoint}
      cacheOptions
      defaultOptions={options}
      value={value}
      loadOptions={loadOptions}
      onChange={onChange}
      placeholder={placeholder}
      isLoading={loading}
      loadingMessage={() => "Loading..."}
      styles={{
        menu: (styles) => ({ ...styles, zIndex: 10 }),
      }}
      {...props}
    />
  );
};

export default AsyncDropdownNormal;